import { gsap } from 'gsap/all'

// Preloader
export default class Preloader {
  constructor() {
    this.html = document.querySelector('html')
    this.body = document.querySelector('body')
    this.preloader = document.querySelector('.js-preloader')
    this.logo = document.querySelector('.js-preloader-logo')
    this.init()
  }
  init() {}
  opening() {
    return new Promise((resolve) => {
      const opentl = gsap.timeline()
      opentl.to(
        this.logo,
        {
          duration: 0.6,
          autoAlpha: 1,
          ease: 'power2.out',
          onComplete: () => {
            resolve()
          },
        },
        '<',
      )
    })
  }
  openingEnd() {
    this.hide()
    this.preloader.classList.add('is-opening-end')

    gsap.to(this.logo, {
      duration: 0.6,
      autoAlpha: 0,
      delay: 0.1,
      ease: 'power3.out',
    })
  }
  hide() {
    this.preloader.classList.remove('is-loading')
    gsap.to(this.preloader, {
      duration: 0.6,
      autoAlpha: 0,
      delay: 0.1,
      display: 'none',
      ease: 'power2.out',
    })
  }
  loading() {
    this.preloader.classList.add('is-loading')
    gsap.to(this.preloader, {
      duration: 0.6,
      autoAlpha: 1,
      delay: 0,
      display: 'block',
      ease: 'power2.out',
    })
  }
}
